<template>
  <div class="color">
    <form class="color__form" @submit.prevent="updatecolor">
      <div class="color__line">
        <text-input
          :value="model.name"
          :name="$t('colors.name')"
          :placeholder="$t('colors.name')"
          :width="240"
          @change="model.name = $event"
        />
        <text-input
          :value="model.value"
          :name="$t('colors.code')"
          :placeholder="$t('colors.code')"
          :width="240"
          @change="model.value = $event"
        />
      </div>
      <div class="color__line">
        <multiple-select
          v-if="model.isLoading"
          :name="$t('colors.category')"
          :options="prepareOptions(types)"
          :value="model.types"
          class="color__select"
          @change="model.types = $event"
        />
      </div>
      <div class="button-container">
        <button class="button-submit" type="submit">{{ $t('lk.save') }}</button>
      </div>
    </form>
    <div class="message">{{ message }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { api } from '@/api';
import { errorHandler } from '@/mixins';
import { allTypes } from '@/components/admin-panel/color/types';
import TextInput from '../../inputs/text-input/TextInput.vue';
import MultipleSelect from '../../inputs/multiple-select/MultipleSelect.vue';

export default {
  name: 'Color',
  components: { TextInput, MultipleSelect },
  mixins: [errorHandler],
  data() {
    return {
      color_id: this.$route.params.id,
      types: allTypes,
      model: {
        types: [],
        name: '',
        value: '',
        isLoading: false
      },
      message: ''
    };
  },
  computed: {
    ...mapState(['auth', 'user'])
  },
  mounted() {
    api.get(`/colors/${this.color_id}`).then((res) => {
      if (res.error) {
        this.message = `Error ${res.error}`;
        return;
      }
      this.model = res.result;
      this.model.types = this.prepareValue();
      this.model.isLoading = true;
    });
  },
  methods: {
    updatecolor() {
      const data = this.prepareModelTypesAfterUpdate(this.model);

      api
        .patch(`/colors/${this.color_id}`, JSON.stringify(data))
        .then((res) => {
          if (res.message) return this.messageHandler(`Error ${res.message}`);
          window.setTimeout(this.redirectTocolors, 1000);
          return this.messageHandler(this.$t('colors.saveded_successfully'));
        })
        .catch((error) => {
          this.messageHandler(`Error ${error}`);
        });
    },
    redirectTocolors() {
      window.location.href = `${window.location.origin}/colors`;
    },
    prepareOptions(types) {
      return types.map((type) => {
        return {
          id: type.value,
          name: type.lang[this.$i18n.locale.slice(0, 2)]
        };
      });
    },
    prepareValue() {
      const items = this.types.filter((type) => this.model.types.includes(type.value));
      return this.prepareOptions(items);
    },
    prepareModelTypesAfterUpdate(m) {
      const model = { ...m };
      const typesId = model.types.map((item) => item.id);
      model.types = typesId;
      return model;
    }
  }
};
</script>

<style lang="scss">
.button-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.delete-material-btn {
  border: 0;
}

.delete-material-btn:hover {
  cursor: pointer;
}

.color {
  // .color__form
  &__form {
  }
  // .color__line
  &__line {
    margin: 0px 0px 20px 0px;
    .input__container {
      margin-bottom: 0;
    }
  }
  // .color__select
  &__select {
    width: 240px;
  }
}
</style>
